import { useTranslations } from "next-intl";
import { CalloutRoot, CalloutText } from "@components/theming";

interface EventDisabledErrorProps {
  reason: "promoter" | "event" | "website";
}

export default function EventDisabledError({
  reason,
}: EventDisabledErrorProps) {
  const t = useTranslations("EventPage");

  return (
    <CalloutRoot
      size="2"
      color="yellow"
      shopsiteClasses="!p-2 rounded-lg !bg-orange-100 !text-orange-700 ring-2 ring-orange-600 w-full mt-4"
      whitelabelClasses="mb-4"
    >
      <CalloutText>{t(`statuses.disabledby${reason}.description`)}</CalloutText>
    </CalloutRoot>
  );
}
